import { render } from "./EmptySaveBtns.vue?vue&type=template&id=4c1a3a4c&scoped=true"
import script from "./EmptySaveBtns.vue?vue&type=script&lang=js"
export * from "./EmptySaveBtns.vue?vue&type=script&lang=js"

import "./EmptySaveBtns.vue?vue&type=style&index=0&id=4c1a3a4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1a3a4c"]])

export default __exports__